import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1637.71751 1.13686838e-13C1731.11711 1.13686838e-13 1807.12429 76.0071763 1807.12429 169.406782L1807.12429 1750.53675C1807.12429 1844.04929 1731.11711 1919.94353 1637.71751 1919.94353L451.870033 1919.94353 451.870033 1.13686838e-13 1637.71751 1.13686838e-13zM1158.70144 581L1078.83997 660.861472 1321.26217 903.283677 667 903.283677 667 1016.22485 1321.26217 1016.22485 1078.83997 1258.64706 1158.70144 1338.50853 1537.4557 959.754265 1158.70144 581zM225.937855 1920L338.87571 1920 338.87571.0564689274 225.937855.0564689274z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconExpandStartSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconExpandStartSolid, _Component);

  var _super = _createSuper(IconExpandStartSolid);

  function IconExpandStartSolid() {
    _classCallCheck(this, IconExpandStartSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconExpandStartSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconExpandStart",
        viewBox: "0 0 1920 1920",
        bidirectional: true
      }), _ref);
    }
  }]);

  IconExpandStartSolid.displayName = "IconExpandStartSolid";
  return IconExpandStartSolid;
}(Component);

IconExpandStartSolid.glyphName = 'expand-start';
IconExpandStartSolid.variant = 'Solid';
IconExpandStartSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconExpandStartSolid;
export { IconExpandStartSolid };